
<!--  -->
<template>
  <div class="comContent">
    <div class="header">
      <el-form
        ref="searchTool"
        :model="searchTool"
        :inline="true"
        style="text-align: left"
      >
        <el-form-item prop="name">
          <el-input
            v-model="searchTool.name"
            placeholder="按活动名称搜索"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <MyButton type="primary" text="检索" @click="getActivityList()" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset()">重置</el-button>
        </el-form-item>
        <el-form-item>
          <MyButton type="primary" text="新建活动" @click="initActivity()" />
        </el-form-item>
      </el-form>
    </div>
    <div class="center">
      <div class="left-part">
        <MyTable
          :table-data="tableData"
          :index="index"
          :showpage="false"
          :selection="false"
          :page="page"
          :operation="true"
          :table-option.sync="tableOption"
        >
          <template slot="menu" slot-scope="scope">
            <el-link
              :underline="false"
              type="primary"
              @click="editDetail(scope.row)"
              >详情</el-link
            >
            <el-link
              :underline="false"
              v-if="scope.row.status === 1"
              style="margin-left: 10px"
              type="primary"
              @click="submit(scope.row)"
              >提交</el-link
            >
          </template>
        </MyTable>
      </div>
      
        
        <div class="rt-content right-part"> 
           <div class="right-header"  v-if="mode === 'edit'">
            <el-button size="small"  @click="save()"
              >保存</el-button
            >
          </div>
            <!-- <el-divider v-if="mode === 'edit'"/> -->
            <el-form
              ref="couponForm"
              label-width="120px"
              class="product"
              :model="formTool"
              :rules="rules"
              size="small"
            >
              <div class="base-info">
                <div class="left_topic mb20">基本信息</div>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="活动名称:" prop="name">
                      <el-input
                        v-model="formTool.name"
                        :disabled="mode === 'view'"
                        placeholder="请输入商品名称"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="活动时间" prop="date">
                      <el-date-picker
                        :disabled="mode === 'view'"
                        v-model="formTool.date"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        size="small"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="活动类型" prop="type">
                      <el-select
                        size="small"
                        v-model="formTool.type"
                        :disabled="mode === 'view'"
                        clearable
                        placeholder="活动类型"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="base-info">
                <div class="left_topic mb20">优惠券类型、规则与数量</div>
                <div class="custom-table">
                  <el-table
                    :data="formTool.couponList"
                    style="width: 100%"
                    hight="100%"
                  >
                    <el-table-column prop="name" label="券类型" width="180">
                      <template slot-scope="scope">
                        <el-form-item prop="useAreaType" label-width="0">
                          <div class="row-item">
                            <span class="content">满减券</span>
                            <el-select
                              size="small"
                              v-model="scope.row.useAreaType"
                              :disabled="mode === 'view'"
                              placeholder="券类型"
                            >
                              <el-option
                                v-for="item in ticketOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="名称" width="120">
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'couponList.' + scope.$index + '.name'"
                          :rules="{
                            required: true,
                            message: '请填写名称',
                            trigger: 'blur',
                          }"
                          label-width="0"
                        >
                          <el-input
                            v-model="scope.row.name"
                            :disabled="mode === 'view'"
                            placeholder="请填写名称"
                          />
                        </el-form-item>
                      </template>
                    </el-table-column>

                    <el-table-column prop="rule" label="规则" width="360">
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="
                            'couponList.' +
                            scope.$index +
                            '.couponRules.discountAmount'
                          "
                          label-width="0"
                        >
                          <div class="rule">
                            <span class="content">满</span>
                            <el-input
                              v-model="scope.row.couponRules.minPurchase"
                              type="number"
                              :disabled="mode === 'view'"
                              placeholder="请输入金额"
                            />
                            <span class="content">减</span>
                            <el-input
                              v-model="scope.row.couponRules.discountAmount"
                              type="number"
                              :disabled="mode === 'view'"
                              placeholder="请输入金额"
                            />
                          </div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column prop="good" label="配置" width="70">
                      <template slot-scope="scope">
                        <div
                          v-if="scope.row.useAreaType == 'PRODUCT'"
                          @click="chooseGood(scope.row)"
                          class="row-item sec-content"
                        >
                          指定商品
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="inventoryNumber"
                      label="数量"
                      width="120"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="
                            'couponList.' + scope.$index + '.inventoryNumber'
                          "
                          :rules="{
                            required: true,
                            message: '请填写数量',
                            trigger: 'blur',
                          }"
                          label-width="0"
                        >
                          <el-input
                            v-model="scope.row.inventoryNumber"
                            :disabled="mode === 'view'"
                            placeholder="请填写数量"
                          />
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="expireTime"
                      label="有效日期"
                      width="450"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'couponList.' + scope.$index + '.expireTime'"
                          :rules="{
                            required: true,
                            message: '有效日期',
                            trigger: 'blur',
                          }"
                          label-width="0"
                        >
                          <el-date-picker
                            v-model="scope.row.expireTime"
                            :disabled="mode === 'view'"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="-"
                            start-placeholder="生效日期"
                            end-placeholder="失效日期"
                            type="datetimerange"
                          />
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form>
          </div>

          <el-dialog
            :visible.sync="dialogVisible"
            title="指定商品"
            top="10vh"
            width="1000px"
            :before-close="beforeClose"
          >
            <TicketAssociativeClassification
              v-if="dialogVisible"
              :rowData="rowData"
            >
            </TicketAssociativeClassification>
          </el-dialog>
      
      </div>
    </div>

</template>

<script>
import MyButton from "@/components/myButton";
import MyTable from "@/components/myTable";
import TicketAssociativeClassification from "./dialog/ticketAssociativeClassification";
import {
  getCouponActivitys,
  addCouponActivity,
  getCouponActivityDetail,
  submitCouponActivity,
} from "@/api/coupon";
import { mapGetters } from "vuex";

import avater from "/public/img/default.png";
export default {
  components: { MyButton, MyTable, TicketAssociativeClassification },
  data() {
    return {
      avater: avater,
      text: "",
      clearable: true,
      mode: "edit",
      searchTool: {
        name: "",
      },
      dialogVisible: false,
      formTool: {
        name: "",
        startDate: "",
        endDate: "",
        type: 1,
        couponList: [
          {
            name: "", // SKU名称
            useAreaType: "SHOP", // 单位
            couponType: "DISCOUNT",
            date: ["", ""],
            inventoryNumber: "",
            claimsNumber: "",
            expireTime: "",
            effectiveTime: "", // 有效时间
            skuList: [], // 第三方商品编码
            couponRules: {
              minPurchase: "",
              discountAmount: "",
            },
          },
        ],
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        date: [{ required: true, message: "请选择活动时间", trigger: "blur" }],
        type: [{ required: true, message: "请选择活动类型", trigger: "blur" }],
      },
      ticketOptions: [
        {
          name: "店铺券",
          id: "SHOP",
        },
        {
          name: "商品券",
          id: "PRODUCT",
        },
      ],
      options: [
        {
          name: "店铺活动",
          id: 1,
        },
      ],
      rowData: {},
      index: true,
      tableData: [],
      tableOption: [
        { label: "活动名称", prop: "name", minWidth: "60px" }, // 这里表示自定义列
        { label: "上线时间", prop: "startDate" },
      ],
      page: {
        total: 10,
        current: 1,
        size: 100,
      },
    };
  },
  computed: {
    ...mapGetters(["couponGoods"]),
  },
  watch: {},
  created() {
    this.getActivityList();
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    initActivity() {
      this.mode = "edit";
      this.formTool = {
        name: "",
        startDate: "",
        endDate: "",
        type: 1,
        couponList: [
          {
            name: "", // SKU名称
            useAreaType: "SHOP", // 单位
            couponType: "DISCOUNT",
            date: ["", ""],
            inventoryNumber: "",
            claimsNumber: "",
            expireTime: "",
            effectiveTime: "", // 有效时间
            skuList: [], // 第三方商品编码
            couponRules: {
              minPurchase: "",
              discountAmount: "",
            },
          },
        ],
      };
    },
    // 关闭弹窗
    beforeClose() {
      this.dialogVisible = false;
    },
    getActivityList() {
      const params = {
        current: this.page.current,
        size: this.page.size,
        ...this.searchTool,
      };
      getCouponActivitys(params).then((res) => {
        this.tableData = res.reverse();
        // this.page.total = res.data.total
        // this.tableData.forEach(item => {
        //   item.type = drugenumeration(item.type)
        // })
      });
    },
    reset() {
      this.$refs.searchTool.resetFields();
      this.getActivityList();
    },
    chooseGood(row) {
      this.dialogVisible = true;
      this.rowData = row;
    },
    submit(row) {
      submitCouponActivity(row.id).then((res) => {
        this.$message.success("提交成功");
        this.getActivityList();
      });
    },
    save() {
      this.$refs["couponForm"].validate((valid) => {
        if (!valid) {
          return;
        }
        const data = {
          ...this.formTool,
          couponList: this.formTool.couponList.map((item) => {
            return {
              ...item,
              skuSet: this.couponGoods.map((item) => item.skuId),
              effectiveTime: item.expireTime[0],
              expirationTime: item.expireTime[1],
            };
          }),
          startDate: this.formTool.date[0],
          endDate: this.formTool.date[1],
        };
        addCouponActivity(data).then((res) => {
          if (res.id) {
            this.formTool.id = res.id;
            this.$message.success("保存成功");
            this.mode = "view";
            this.getActivityList();
          }
        });
      });
    },
    editDetail(row) {
      getCouponActivityDetail(row.id).then((res) => {
        this.formTool = res;
        this.formTool.date = [res.startDate, res.endDate];
        this.formTool.type = Number(res.type);
        this.formTool.couponList = this.formTool.couponList.map((item) => {
          return {
            ...item,
            expireTime: [item.effectiveTime, item.expirationTime],
          };
        });
        this.mode = "view";
      });
      // this.$router.push(
      //   {
      //     path: '/productManage/auditProduct-edit',
      //     query: { goodsId: row.goodsId }
      //   }
      // )
    },
  },
};
</script>
<style lang='scss' scoped>
.comContent {
  padding: 0;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
  .el-form-item {
    margin: 0px 0px 0px 8px !important;
  }
}
.center {
  margin-top: 16px;
  padding: 0 24px 10px 24px;
  height: calc(100% - 81px);
  display: flex;
  justify-content: space-between;
  .left-part {
    // float: left;
    width: 30%;
    border: 1px solid #ccc;
    padding: 10px 10px 0;
    margin-bottom: 10px;
    border-radius: 5px;
    ::v-deep .el-table__body-wrapper {
      min-height: 400px;
    }
  }
  .right-part {
    // float: right;
    width: 70%;
     border: solid 1px #ccc;
    border-radius: 5px;
    padding: 0 10px 10px;
    height: min-content;
    margin-bottom: 10px;
    margin-left: 10px;
    .right-header {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      //  background: #f5f5f5;
      padding:10px 0px 10px; 
      
      border-bottom: 1px solid #ebeef5;
      margin-bottom:10px ;
    }
    .base-info {
      margin-top: 10px;
      border: 1px solid #ccc;
      padding: 10px 10px 10px;
      border-radius: 5px;
      .custom-table {
        overflow: auto;
      }
      ::v-deep .el-table {
        height: 100%;
        .el-table__body-wrapper {
          overflow-x: auto !important;
        }
      }
      .sec-content {
        margin-bottom: 20px;
        cursor: pointer;
      }
      .row-item {
        display: flex;
        white-space: nowrap;
        ::v-deep .e-select {
          width: 80px !important;
        }
      }
      .rule {
        display: flex;
        ::v-deep .el-input__inner {
          width: 90px;
        }
      }
      // ::v-deep .el-form-item__content {
      //   margin-left: 0px!important;
      // }
      .content {
        margin-right: 5px;
        margin-left: 5px;
      }
    }
  }
  ::v-deep .imageP {
    width: calc(100% - 110px);
    p {
      margin: 0 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.rt-content {
 
  // padding: 0 10px 10px;
}
</style>
